import { random } from "lodash";

export function randomElement(options) {
  return options.length > 0 ? options[random(0, options.length - 1)] : null;
}

export function randomJSExpression(maxDepth = 5) {
  const option = Math.max(Math.floor(7 * Math.pow(Math.random(), 2)), depth > 5 ? 2 : 1000);
  switch (option) {
    case 0:
      return String(Math.random());
    case 1:
      return String(Math.floor(10 * Math.random()));
    case 2:
      return `row[${randomElement([..."0123456789"])}]`;
    case 3:
      return `(${rnd()} ${randomElement([..."+-*/"])} ${rnd(depth + 1)})`;
    case 4:
      return `${randomElement(["Math.floor", "Math.abs", "Math.sqrt"])}(${rnd(depth + 1)})`;
    case 5:
      return `${randomElement(["Math.pow"])}(${rnd(depth + 1)}, ${rnd(depth + 1)})`;
    case 6:
      return `(${rnd(depth + 2)} < ${rnd(depth + 2)} ? ${rnd(depth + 1)} : ${rnd(depth + 1)})`;
    default:
      return "";
  }
}

export function randomString() {
  return Math.random() < 0.5 ? randomElement(["xyz", "Иванов", "Пётр Первый", "1234", "945-999-99-99", "f@#%*", ""]) : randomJSExpression();
}

export function updateTables(datas) {
  let newTables = {};
  const keys = [
    "tbl-1-1", "tbl-1-2", "tbl-1-3", "tbl-1-4", "tbl-1-5", "tbl-1-6-1", "tbl-1-6-2", "tbl-1-7", 
    "tbl-2-1", "tbl-2-2-1", "tbl-2-2-2", "tbl-2-2-3", "tbl-2-3-1", "tbl-2-3-2", "tbl-2-3-3", "tbl-2-4-1", 
    "tbl-2-4-2", "tbl-5-1", "tbl-5-2", "tbl-5-3",
  ];
  for(let i = 0; i < keys.length; i++){
    newTables[keys[i]] = {};
    newTables[keys[i]].leftEmpty = false;
    if(datas[keys[i]]){
      if(Array.isArray(datas[keys[i]])){
        newTables[keys[i]].data = datas[keys[i]];
      }
      else {
        newTables[keys[i]] = datas[keys[i]];
      }
      
    }
    else {
      newTables[keys[i]].data = [];
    }
  }
  return newTables;
}
